export default function ResumeImprovements({ data }) {

  if (!data?.improvements?.length) return null;

  return (
    <div className="bg-white p-6 rounded-2xl shadow">

      <h3 className="text-lg font-semibold mb-4 flex items-center gap-2">
        🛠 Suggested Improvements
      </h3>

      <div className="space-y-3">

        {data.improvements.map((item, i) => (
          <div
            key={i}
            className="flex gap-3 items-start bg-gray-50 border px-4 py-3 rounded-lg"
          >
            <span className="text-green-600 font-bold">✔</span>

            <p className="text-sm text-gray-700">
              {item}
            </p>
          </div>
        ))}

      </div>
    </div>
  );
}